import { Injectable } from '@angular/core';
import { NzIconService } from 'ng-zorro-antd/icon';
import * as IconSvgs from './iconSvgs';


@Injectable({
  providedIn: 'root'
})
export class IconService {

  constructor(private nzIconService: NzIconService) { }

  public addIconLiteral(val: string) {
    const iconSvgs: { [props: string]: string } = IconSvgs;
    const iconType: string = val.replace(/-/g, '').toUpperCase();
    this.nzIconService.addIconLiteral(`ng-zorro:${val}`, iconSvgs[iconType]);
  }
}
